import { inkSystem, inkSystemSmall } from '@ds/icons'

const icons = {
  small: inkSystemSmall.icons,
  default: inkSystem.icons,
}

export default icons
